import { render, staticRenderFns } from "./ClassSubjectStudentTypes.vue?vue&type=template&id=39089c88&"
import script from "./ClassSubjectStudentTypes.vue?vue&type=script&lang=ts&"
export * from "./ClassSubjectStudentTypes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports